import { StockVisual } from '../../components/StockVisual';
import { GoogleTagManager as googleTagManager } from '../../libraries/GoogleTagManager';

class CatalogIndex {
    init() {
        const stockVisual = new StockVisual();

        if (useGtmEcommerceEvents) {
            document.dispatchEvent(new CustomEvent('GTMViewItemList'));

            let items = document.querySelectorAll('.item');

            if (items) {
                items.forEach(item => {
                    item.addEventListener('click', Event => {
                        document.dispatchEvent(new CustomEvent('GTMSelectItem',  {
                            detail: {
                                itemElement: item,
                                itemId: item.dataset.modelNo,
                                itemName: item.querySelector('.info-block h5 a') ? item.querySelector('.info-block h5 a').innerHTML : '',
                                colorElements: item.querySelectorAll('.item-colors .color'),
                                itemPrice: item.querySelector('.price span') ? item.querySelector('.price span').innerHTML.trim() : '',
                            }
                        }));
                    });
                });
            }
        }

        stockVisual.init();
        this.quickOrderModal();
    }

    quickOrderModal() {
        document.addEventListener('click', async (e) => {
            if (e.target.matches('*[data-role=quickOrder]')) {
                const el = e.target;
              
                loadOrdermatrixContent(el.dataset.modelNo);
                openQuickorderModal();
            }
          });
    }
}

addEventListener('DOMContentLoaded', e => {
    const catalogIndex = new CatalogIndex();

    catalogIndex.init();
});
